import { createAction } from '../../../../store.model';
import { CaMeetingRequestContext } from '../../core';
import { ActionType } from '../ca-analysis-dialog.action';

export interface ReceiveMeetingRequestContext {
    caMeetingRequestContext: CaMeetingRequestContext;
}

export const receiveMeetingRequestContext = createAction<
    ActionType,
    ReceiveMeetingRequestContext
>(ActionType.COACHING__CA__RECEIVE_MEETING_REQUEST_CONTEXT);
